import { ArhamState } from '../mascotTypes';
import arhamPointImg from '../../../assets/mascot/arham/arham-point.webp';
import arhamWaveImg from '../../../assets/mascot/arham/arham-wave.webp';

export const ARHAM_ASSETS: Record<ArhamState, string> = {
  idle: arhamPointImg,
  point: arhamPointImg,
  learn: arhamPointImg,
  listen: arhamPointImg,
  wave: arhamWaveImg,
  celebrate: arhamWaveImg,
};

export function getArhamAsset(state: ArhamState): string {
  return ARHAM_ASSETS[state] || arhamPointImg;
}
